export class UiSelect {
    constructor() {
        this.isSelected = false;
    }
    select() {
        this.isSelected = true;
    }
    deSelect() {
        this.isSelected = false;
    }
    toggle() {
        this.isSelected = !this.isSelected;
    }
}